<template>
  <el-dialog title="选择临床业务科室" :append-to-body="true" :visible.sync="showTag" width="30%">
    <el-form :model="form" label-width="100px" size="mini">
      <el-form-item label="医务部">
        <el-select v-model="form.transferBusinessDeptId" filterable placeholder="请选择">
          <el-option v-for="(item,index) in deptList" :label="item.deptName" :value="item.id"
                     :key="index"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer">
      <el-button @click="hide" size="mini">取 消</el-button>
      <el-button type="primary" @click="sub" size="mini" :loading="appShowLoading">确定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import {staffService} from "../service/staff";
import {USER_TYPE} from "../../../common/lib/config";
import {STAFF_PROCESS_ORDER_SUCCESS} from "../events";
import {isEmpty} from "../../../common/lib/utils";
import {timeFilter} from "../../../common/lib/filters";
import {disabledDate} from "../filter";

export default {
  name: "select-dept-dialog",
  props: {
    aspectUser: String
  },
  data() {
    return {
      showTag: false,
      deptList: [],
      form: {
        transferBusinessDeptId: ''
      },
      info: {}
    }
  },
  computed: {
    selectedDept() {
      return this.deptList.find(dept => dept.id === this.form.transferBusinessDeptId) || {}
    }
  },
  methods: {
    show(info) {
      this.info = info;
      this.showTag = true;
      this.getDept();
    },
    hide() {
      this.showTag = false;
    },
    async getDept() {
      this.deptList = await staffService.listDept();
    },

    sub() {
      this.$confirm(`确定选择${this.selectedDept.deptName}吗？`)
          .then(async () => {
            const code = await staffService.orderExamine({
              orderId: this.info.id,
              auditStatus: true,
              transferBusinessDeptId: this.form.transferBusinessDeptId
            });
            if (code === '0') {
              this.$message.success('操作成功');
              bus.$emit(STAFF_PROCESS_ORDER_SUCCESS.id, 1);
              this.hide();
            }
          })
    }
  },
}
</script>

<style scoped>
</style>
